export const getIntLinkUrlUtil = (
  deepLink,
  cardType,
  hasBadge
) => {
  const connector = deepLink?.includes('?') ? '&' : '?';

  return `${deepLink}${connector}intlink=us-travel-hp-L1-${encodeURIComponent(cardType?.toLowerCase())}card-${hasBadge ? 'badge' : 'nobadge'}`;
};
